export default __webpack_public_path__ + "static/media/k.cfeb0c9e.mp3";